/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { CursorManager } from '../../../core/navigation';
import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { setHideAdultContentSettingHighlightPositionAction } from './hideadultcontent.actions';
import {
    SET_HIDE_ADULT_CONTENT_SETTING_HIGHLIGHT_POSITION,
    SET_HIDE_ADULT_CONTENT_SETTING_VERTICAL_LIMIT,
    SET_HIDE_ADULT_CONTENT_STATE,
} from './hideadultcontent.types';

interface IHideAdultContentSettings {
    verticalLimit: number;
    verticalPosition: number;
    hideAdultContent: boolean;
    isFocused: boolean;
}

const initialState: IHideAdultContentSettings = {
    verticalLimit: 0,
    verticalPosition: 0,
    hideAdultContent: true,
    isFocused: true,
};

const hideAdultContentReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<IHideAdultContentSettings>>{},
) => {
    switch (type) {
        case SET_HIDE_ADULT_CONTENT_SETTING_VERTICAL_LIMIT:
            return {
                ...state,
                verticalLimit: payload.verticalLimit,
            };
        case SET_HIDE_ADULT_CONTENT_STATE:
            return {
                ...state,
                hideAdultContent: payload.hideAdultContent,
            };
        case SET_HIDE_ADULT_CONTENT_SETTING_HIGHLIGHT_POSITION:
            return {
                ...state,
                isFocused: payload.isFocused,
                verticalPosition: payload.verticalPosition,
            };
        default:
            return state;
    }
};

export const onCursorStateChangeHideAdultContentOperations =
    () => (dispatch: Function, getState: Function) => {
        const { verticalPosition } = getState().hideAdultContent;
        if (CursorManager.isCursorAppeared()) {
            dispatch(setHideAdultContentSettingHighlightPositionAction(verticalPosition, false));
        } else {
            dispatch(setHideAdultContentSettingHighlightPositionAction(verticalPosition, true));
        }
    };

export default hideAdultContentReducer;
